import type { ComputedRef } from 'vue'

import { resolveUrl } from '@shared/lib/url'
import { AppRoute } from '@shared/config'

import { useKidStore } from './store'
import { useKidDeleteApi } from '../api/delete.hook'

interface ModalKidDeleteReturn {
  refIsOpen: ComputedRef<boolean>
  refIsLoading: ComputedRef<boolean>
  refKidName: ComputedRef<string>
  closeModal: () => void
  confirmDelete: () => void
}

export const useModalKidDelete = (): ModalKidDeleteReturn => {
  const kidStore = useKidStore()

  const refIsOpen = computed<boolean>(() => kidStore.isModalDeleteOpen)
  const refIsLoading = computed<boolean>(() => kidStore.isProcessing)
  const refKidName = computed<string>(() => kidStore.getKid?.name ?? '')

  const closeModal = (): void => {
    kidStore.setModalDelete(false)
  }

  const submit = async (): Promise<void> => {
    const kid = kidStore.getKid
    if (!kid) return

    const isDeleted = await useKidDeleteApi(kid.id)
    closeModal()

    if (!isDeleted) return

    const customerPath = resolveUrl(AppRoute.CustomersShow, { id: kid.customer_id })
    if (customerPath) {
      await navigateTo(customerPath)
    }
  }

  const confirmDelete = (): void => {
    void submit()
  }

  return {
    refIsOpen,
    refIsLoading,
    refKidName,
    closeModal,
    confirmDelete,
  }
}
